import { HamburgerButton } from "~/components/HamburgerButton";
import { useEffect, useId, useRef, useState } from "react";
import { Box, Grid } from "@radix-ui/themes";
import { SidebarMenu } from "~/components/SidebarMenu";
import styles from "./sidebar.module.css";
import { useLocation } from "@tanstack/react-router";

export function Sidebar() {
	const [open, setOpen] = useState(false);
	const menuId = useId();
	const triggerRef = useRef<HTMLButtonElement>(null);

	const pathname = useLocation({ select: (location) => location.pathname });

	useEffect(() => {
		if (pathname) {
			setOpen(false);
		}
	}, [pathname]);

	useEffect(() => {
		if (!open) {
			return;
		}

		const previousBodyOverflow = document.body.style.overflow;
		const previousDocumentOverflow = document.documentElement.style.overflow;

		document.body.style.overflow = "hidden";
		document.documentElement.style.overflow = "hidden";
		const closeOnEscape = (event: KeyboardEvent) => {
			if (event.key === "Escape") {
				setOpen(false);
				triggerRef.current?.focus();
			}
		};
		document.addEventListener("keydown", closeOnEscape);

		return () => {
			document.body.style.overflow = previousBodyOverflow;
			document.documentElement.style.overflow = previousDocumentOverflow;
			document.removeEventListener("keydown", closeOnEscape);
		};
	}, [open]);

	return (
		<Grid columns="1" rows="1">
			<Box gridColumn="1" gridRow="1" position="relative">
				{/* Keep the real navigation links in SSR; closed menus are inert to users. */}
				<nav
					id={menuId}
					aria-label="Main navigation"
					aria-hidden={!open}
					inert={!open}
					data-state={open ? "open" : "closed"}
					className={styles.sidebar}
				>
					<SidebarMenu />
				</nav>
			</Box>
			<Box
				gridColumn="1"
				gridRow="1"
				style={{
					zIndex: "100",
				}}
			>
				<HamburgerButton
					isOpen={open}
					controls={menuId}
					buttonRef={triggerRef}
					onOpenChange={(isOpen) => {
						setOpen(isOpen);
					}}
				/>
			</Box>
		</Grid>
	);
}
